<template>
    <div class="leftBottom">
        <div class="ad">
            <div class="filterBox"></div>
            <p class="title">专家数据</p>
            <div id="rightPie" v-if="show" style="width: 420px; height: 250px"></div>
        </div>
    </div>
</template>

<script>
import echarts from 'echarts';
export default {
    props: {
        sourceData: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            myChart: '',
            labelData: ['法律', '心理', '健康'],
            zjFL: [0, 0, 0],
            show: false
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.getzj();
    },
    watch: {},
    methods: {
        getzj() {
            this.$http.ajax({ method: 'get', url: 'thinktanks', data: { per_page: 10000, type: 2 } }).then((res) => {
                this.zjData = res.data;
                this.filterData(res.data);
            });
        },
        filterData(d) {
            for (let i = 0; i < d.length; i++) {
                if (d[i].exp_type == 1) {
                    this.zjFL[0] = this.zjFL[0] + 1;
                } else if (d[i].exp_type == 2) {
                    this.zjFL[1] = this.zjFL[1] + 1;
                } else {
                    this.zjFL[2] = this.zjFL[2] + 1;
                }
            }
            setTimeout(() => {
                this.show = true;
                this.$nextTick(() => {
                    this.myChart = echarts.init(document.getElementById('rightPie'), null, {
                        devicePixelRatio: 2
                    });
                    this.setOption();
                });
            }, 1000);
        },
        setOption() {
            var baseOption = {
                grid: {
                    left: '40px', //距离左边的距离
                    right: '40px', //距离右边的距离
                    bottom: '30px', //距离下边的距离
                    width: '400px',
                    height: '170px'
                    // top: "10%" //距离上边的距离
                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.labelData,
                        axisLabel: {
                            textStyle: {
                                color: '#ffffff',
                                fontSize: 14,
                                fontFamily: 'Microsoft YaHei'
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: '#fff',
                                fontSize: 14,
                                fontFamily: 'Microsoft YaHei'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(0, 194, 255, 0.5)',
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            textStyle: {
                                color: '#fff',
                                fontSize: 12,
                                fontFamily: 'Microsoft YaHei'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        }
                    }
                ],
                series: [
                    {
                        name: '专家人数',
                        type: 'bar',
                        data: this.zjFL,
                        barCategoryGap: '60%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(0,194,255,1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(0,194,255,0)'
                                    }
                                ])
                            },
                            emphasis: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(0,194,255,1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(0,194,255,0)'
                                    }
                                ])
                            }
                        }
                    }
                ]
            };

            this.myChart.setOption(baseOption, true);
        }
    },
    components: {}
};
</script>
<style scoped lang="scss">
.leftBottom {
    position: absolute;
    right: 50px;
    top: 460px;
    .filterBox {
        background: rgba($color: #000000, $alpha: 0.4);
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        z-index: -1;
        -webkit-filter: blur(9px);
        -moz-filter: blur(9px);
        -o-filter: blur(9px);
        -ms-filter: blur(9px);
        filter: blur(30px);
    }
    .ad {
        position: relative;
        background: url(../../assets/img/card.png) no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        width: 470px;
        height: 280px;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 18px;
    }
}
.title {
    position: absolute;
    background: rgba($color: #00c2ff, $alpha: 0.6);
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    padding: 5px 10px;
    display: inline-block;
}
</style>
